'use strict';

var novicell = novicell || {};
var checkImages = checkImages || new function() {}();

novicell.productImageSlider =
    novicell.productImageSlider ||
    (function() {
        var sliderLargeClass = 'm-productImageSlider__list';
        var sliderSmallClass = 'm-productImageSlider__listSmall';
        var hiddenModifier = '--isHidden';
        var startSlide = 0;
        function init() {
            var productImageSliderMain = document.querySelector('.' + sliderLargeClass);
            var productImageSliderThumbs = document.querySelector('.' + sliderSmallClass);
            if (productImageSliderMain != null && productImageSliderThumbs != null) {
                //Flickity - no FOUC
                var carouselLarge = document.querySelector('.' + sliderLargeClass + hiddenModifier);
                var carouselSmall = document.querySelector('.' + sliderSmallClass + hiddenModifier);
                carouselLarge.classList.remove(sliderLargeClass + hiddenModifier);
                carouselSmall.classList.remove(sliderSmallClass + hiddenModifier);
                // carouselLarge.offsetHeight;
                // carouselSmall.offsetHeight;

                var flkty = new Flickity(productImageSliderMain, {
                    // options
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: true,
                    prevNextButtons: false,
                    pageDots: false,
                    selectedAttraction: 1,
                    friction: 1,
                    imagesLoaded: true
                });

                var flkty2 = new Flickity(productImageSliderThumbs, {
                    contain: true,
                    asNavFor: productImageSliderMain,
                    prevNextButtons: false,
                    pageDots: false
                });

                initOverlayEvents(); //sliders must be initiated before this line
            } else {
                //if there's only one image
                if (productImageSliderMain != null) {
                    initSingleImageOverlay(productImageSliderMain);
                }
            }
        }
        function initSingleImageOverlay(productImageSliderMain) {
            var tempHolderClass = 'o-productDetails__temp';
            var imageHolder = productImageSliderMain.querySelector('.m-productImageSlider__slideHolder');
            if (imageHolder != null) {
                var productImageSlider = document.getElementsByClassName('m-productImageSlider')[0];
                if (productImageSlider != null) {
                    var clone = productImageSlider.cloneNode(true);
                    var cloneSlideHolder = clone.querySelector('.m-productImageSlider__slideHolder');
                    cloneSlideHolder.classList.add('overlay-slideHolder');
                    cloneSlideHolder.removeAttribute('style');
                    var cloneSlideSrc = cloneSlideHolder.querySelector('img').dataset.src;
                    var cloneSlideAlt = cloneSlideHolder.querySelector('img').alt;
                    cloneSlideHolder.innerHTML = '<img class="slide-image" src="' + cloneSlideSrc + '" alt="' + cloneSlideAlt + '" />';
                    var temp = document.getElementById(tempHolderClass);
                    if (temp != null) {
                        temp.appendChild(clone);
                    }
                }
                checkImages();

                imageHolder.addEventListener('click', function() {
                    novicell.overlay.create({
                        selector: '#' + tempHolderClass,
                        class: 'novi-overlay--productSliderOverlay'
                    });
                });
            }
        }

        function initOverlayEvents() {
            var slides = document.querySelectorAll('.m-productImageSlider__item .m-productImageSlider__slideHolder');
            for (var i = 0; i < slides.length; i++) {
                slides[i].addEventListener('click', makeSliderOverlay, false);
            }
        }

        function makeSliderOverlay() {
            startSlide = findStartSlideNumber(this);
            novicell.overlay.create({
                selector: '#overlayContent--productImageSlider',
                class: 'novi-overlay--productSliderOverlay',
                onLoaded: makeOverlayInSlider
            });
        }
        function makeOverlayInSlider() {
            var listForSlider = document.querySelector('#js-novi-overlay .m-productImageSlider__listOverlay');
            var flkty3 = new Flickity(listForSlider, {
                // options
                initialIndex: startSlide,
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: true,
                pageDots: false,
                selectedAttraction: 1,
                friction: 1,
                imagesLoaded: true,
                on: {
                    ready: function() {
                        //so you can use arrow keys to navigate slider
                        this.element.focus();
                    }
                }
            });
            flkty3.on('select', function() {
                // console.log(this.selectedSlide.cells[0].element);
                var videoIframeClass = 'm-productImageSlider__videoIframe';

                var iframesWithSrc = this.element.querySelectorAll('.' + videoIframeClass + '[src]');
                for (var i = 0; i < iframesWithSrc.length; i++) {
                    //stop iframe from playing when not active
                    iframesWithSrc[i].removeAttribute('src');
                }

                var currentElement = this.selectedSlide.cells[0].element;
                var iframe = currentElement.querySelector('.' + videoIframeClass);
                var isVideoSlide = iframe != null;
                if (isVideoSlide) {
                    var iframeSrc = iframe.getAttribute('data-src');
                    iframe.setAttribute('src', iframeSrc);
                }
            });
        }

        function findStartSlideNumber(el) {
            var children = el.parentNode.parentNode.childNodes;
            var currentChild = el.parentNode;
            var num = 0;
            for (var i = 0; i < children.length; i++) {
                if (children[i] == currentChild) {
                    return num;
                }
                if (children[i].nodeType == 1) {
                    num++;
                }
            }
            return 0;
        }

        return {
            init: init
        };
    })();
